export const blocks = {};